import React, { FC, useState, useCallback } from 'react';
import { useWindowSize } from 'hooks/breakpoints';
import { TabletGiftCardForm } from 'routes/GiftCard/Form/Tablet';
import { MobileGiftCardForm } from 'routes/GiftCard/Form/Mobile';
import { useGiftCardCart } from 'hooks/context/giftCardCart';
import { GiftCardFormValues } from './model';
import { GIFT_AMOUNT_MIN } from '../const';
import { FormSubmitHandler, Form } from 'components/Form';
import { useSmartNavigate } from 'hooks/useSmartNavigate';

export const GiftCardForm: FC = () => {
  const navigate = useSmartNavigate();
  const { isDesktop } = useWindowSize();
  const { items, update } = useGiftCardCart();

  const [value, setValue] = useState<GiftCardFormValues>({
    amount: items[0]?.amount ?? GIFT_AMOUNT_MIN,
    isCustomer: items[0]?.recipient.isCustomer ?? false,
    name: items[0]?.recipient.name,
    email: items[0]?.recipient.email,
    note: items[0]?.note,
  });

  const handleSubmit: FormSubmitHandler = useCallback((e, isValid) => {
    e.preventDefault();

    if (!isValid) return;

    const { amount, note, ...recipient } = value;

    update(0, { amount, note, recipient });
    navigate('~checkout', { state: { isFromGiftCard: true } });
  }, [navigate, update, value]);

  return (
    <Form onSubmit={handleSubmit} autoScrollToError data-analytics="giftcard">
      {!isDesktop && <MobileGiftCardForm
        value={value}
        onChange={setValue}
        update={!!items[0]}
      />}
      {isDesktop && <TabletGiftCardForm
        value={value}
        onChange={setValue}
        update={!!items[0]}
      />}
    </Form>
  );
};
